import React from 'react';
import { SvgIcon } from '@mui/material';
import { ReactComponent as StatusDotOrange } from 'assets/images/icons/dots/statusdot-orange.svg';
import { IconProps } from 'types/icon';

const StatusDotOrangeIcon: React.FC<IconProps> = ({
    width = '18px',
    height = '18px',
}) => {
    return (
        <SvgIcon
            component={StatusDotOrange}
            inheritViewBox
            style={{ width, height }}
        />
    );
};

export default StatusDotOrangeIcon;
